import React, { useCallback } from 'react';
import { SIMPLE_CARD } from 'src/sections/GroupCards/cardTypes';
import StackedBarChart from '../Simple/echarts/StackedBarChart';
import { BAR, FUNNEL, HORIZONTAL_STACKED, PIE, RADAR } from '../types';
import BarChart from './echarts/BarChart/index-beta';
import FunnelChart from './echarts/FunnelChart/index-beta';
import PieChart from './echarts/PieChart/index-beta';
import RadarChart from './echarts/Radar/index';
import VerticalStackedBarChart from './echarts/VerticalStackedBarChart';

/**
 * @param {string} type type of the chart that will be rendered.
 * where type = pie|bar|funnel
 */
function getSimpleChartComponent(type = 'pie') {
  return {
    [PIE]: PieChart,
    pieGrade: PieChart,
    [BAR]: BarChart,
    [FUNNEL]: FunnelChart,
    [HORIZONTAL_STACKED]: StackedBarChart,
    verticalStacked: VerticalStackedBarChart,
    [RADAR]: RadarChart,
  }[type];
}

export default function SimpleChart({
  type,
  data,
  // configuração das cores carregado da api e mantido pelo redux
  chartFontSize,
  // configuração de cores do gráfico
  colors,
  legendsFilter,
  legendsFilterHandler,
  // a acao (action do redux) de atualizar a cor das barras
  // se subdividiu em duas
  // updateCharColors => corresponde a atualização das cores na api
  // que é chamado ao fechar o color picker
  updateChartColors,
  theme,
  themeTitle,
  // paleta de cores do color picker
  // (memorizadas no local storage e gerenciadas no redux)
  // para que o usuario possa ver as ultimas cores selecionadas
  // na ordem que foram selecionadas
  colorPickerColors,
  // Caso haja erro no fetch da configuração de cores a propriedade de erro terá um valor definido
  // Essa propriedade será utilizada para impedir que o color picker seja aberto desnecessariamente
  error,
  chartRef,
  tipoPergunta,
  ascOrder,
}) {
  const SimpleChartComponent = getSimpleChartComponent(type);

  console.log('[TYPE]: ' + type);
  // Este callback foi acrescentando para garantir que o componente seja atualizado
  // cada vez que as props passadas para ele sejam atualizadas

  const renderSimpleChartComponent = useCallback(() => (
    <SimpleChartComponent
      chartType={type}
      data={data}
      chartFontSize={chartFontSize}
      legendsFilter={legendsFilter}
      legendsFilterHandler={legendsFilterHandler}
      theme={theme}
      themeTitle={themeTitle}
      colors={colors}
      updateChartColors={updateChartColors}
      key={`${theme.title}${error}${ascOrder}`}
      colorPickerColors={colorPickerColors}
      error={error}
      chartRef={chartRef}
      cardType={SIMPLE_CARD}
      tipoPergunta={tipoPergunta}
      ascOrder={ascOrder}
    />
  ), [
    colors,
    data,
    legendsFilter,
    legendsFilterHandler,
    theme,
    themeTitle,
    updateChartColors,
    colorPickerColors,
    chartFontSize,
    error,
    type,
    chartRef,
    tipoPergunta,
    ascOrder
  ]);

  // https://pt-br.reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key
  // O atributo "key" foi acrescentado como uma ferramenta para fazer com que
  // O componente simpleChart seja remontado quando o data do usuario mudar (quando o barchart desabilitar uma opção).
  // através do clique nas legendas.
  return (
    <>
      {/*
        TODO - Acrescentar um ternario para renderizar esse componente caso tenha o array de data,
        caso contrário, renderizar o svg informando o usuario que não foi possível carregar o gráfico da API
       */}
      {renderSimpleChartComponent()}
    </>
  );
}
